import { render, staticRenderFns } from "./AssociationServiceFee.vue?vue&type=template&id=6a11bc5b&scoped=true"
import script from "./AssociationServiceFee.vue?vue&type=script&lang=js"
export * from "./AssociationServiceFee.vue?vue&type=script&lang=js"
import style0 from "./AssociationServiceFee.vue?vue&type=style&index=0&id=6a11bc5b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a11bc5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a11bc5b')) {
      api.createRecord('6a11bc5b', component.options)
    } else {
      api.reload('6a11bc5b', component.options)
    }
    module.hot.accept("./AssociationServiceFee.vue?vue&type=template&id=6a11bc5b&scoped=true", function () {
      api.rerender('6a11bc5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/AssociationServiceFee.vue"
export default component.exports